import { SERVICE_PLATFORM_BASE_URL, TENTH_SEC_BASE_URL } from '~/utils/appInfo';

const MEMBER_BASE_URL = `${SERVICE_PLATFORM_BASE_URL}/member/v1`;
const CONTENTS_TENTH_BASE_URL = `${TENTH_SEC_BASE_URL}/contents_delivery`;

const ANALYSIS_BASE_URL = `${SERVICE_PLATFORM_BASE_URL}/analysis/v1`;

export const API_URLS = {
  /** 계정 */
  MEMBER: {
    /** 내 계좌 정보 */
    MY_ACCOUNT: `${MEMBER_BASE_URL}/members`,
    /** 약정  */
    SERVICE: `${MEMBER_BASE_URL}/account/service`, // /:account_key (required)
    /** 약관 리스트 */
    TERMS_LIST: `${MEMBER_BASE_URL}/account/terms`, // ?service_id_list= (required)
  },
  FOOTER: `${CONTENTS_TENTH_BASE_URL}/footer`,
  BANNER: `${CONTENTS_TENTH_BASE_URL}/banner`,

  ANALYSIS: {
    /** 티아라 tracking_id 조회 */
    TRACKING_ID: `${ANALYSIS_BASE_URL}/user/tracking-id`,
  },
};
